import { Helmet } from 'react-helmet';
import { useLocation } from 'react-router-dom';
import { languages } from '@/i18n/config';
import useLocalization from '@/context/localization/useLocalization';

const FONTS = ['effra/light.ttf', 'effra/regular.ttf', 'effra/semibold.ttf', 'effra/bold.ttf'];

/**
 * This is the global headers that will be imported in index page.
 */
const GlobalHead = () => {
  const { pathname, search } = useLocation();
  const { locale } = useLocalization();
  const path = pathname.replace(`/${locale}`, '');
  const origin = window.location.origin;

  return (
    <Helmet>
      {process.env.VITE_PUBLIC_ENV !== 'production' && <meta name='robots' content='noindex' />}

      {/* Domain & APIs */}
      <link rel='preconnect' href={process.env.VITE_CMS_BASE_URL} />

      {/* Locale */}
      <link rel='alternate' hrefLang='x-default' href={`${origin}/${path}${search}`} />
      {languages.map((lang) => (
        <link
          key={lang}
          rel='alternate'
          hrefLang={lang}
          href={`${origin}/${lang}${path}${search}`}
        />
      ))}

      {/* Canonical */}
      <link rel='canonical' href={`${origin}/${locale}${path}`} />

      {/* OG */}
      {languages.map((lang) => (
        <meta key={lang} rel='og:locale:alternate' content={lang} />
      ))}

      <meta property='og:url' content={`${origin}/${locale}${path}${search}`} />
      <meta property='og:site_name' content={origin} />
      <meta property='og:locale' content={locale} />
      <meta property='og:image' content={`${origin}/images/default-cover.jpg`} />
      <meta property='og:image:alt' content={origin} />
      <meta property='og:type' content='website' />

      {/* Social */}
      <meta name='twitter:card' content='summary_large_image' />
      <meta name='twitter:site' content='@RUHCalendar' />
      <meta name='twitter:image' content={`${origin}/images/default-cover.jpg`} />

      {/* Fonts */}
      {FONTS.map((font) => (
        <link
          key={font}
          rel='preload'
          href={`/fonts/${font}`}
          as='font'
          type={`font/${font.split('.')[1]}`}
          crossOrigin='anonymous'
        />
      ))}
    </Helmet>
  );
};

export default GlobalHead;
